<template>
  <div class="ebDateSearch">
    <el-form label-width="100px" :inline="true">
      <el-form-item label="按时间:">
        <el-radio-group v-model="listRequestData.selected">
          <el-radio class="eb-radio radio" label="0" @change="selectedCurrent">最近一个月</el-radio>
          <el-radio class="eb-radio radio" label="1" @change="selectedCurrent">最近一年</el-radio>
          <el-radio class="eb-radio radio" label="2" @change="selectedCurrent">自定义</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="listRequestData.startTime" type="date" :editable="isEditable" :readonly="isReadonly" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="至" label-width="30px">
        <el-date-picker v-model="listRequestData.endTime" type="date" :editable="isEditable" :readonly="isReadonly" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <slot></slot>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'ebDateSearch',
  props: {
    listRequestData: {}
  },
  data() {
    return {
      isReadonly: true,
      isEditable: false
    };
  },
  created() {
    this.initDate();
    this.selectedCurrent(this.listRequestData.selected);
  },
  methods: {
    initDate: function() {
      this.listRequestData.startTime =
        moment()
          .subtract(1, 'months')
          .format('YYYY-MM-DD') + ' 00:00:00';
      this.listRequestData.endTime = moment().format('YYYY-MM-DD') + ' 23:59:59';
    },
    selectedCurrent: function(label) {
      if (label === '0') {
        this.initDate();
        this.isReadonly = true;
      } else if (label === '1') {
        this.listRequestData.startTime =
          moment()
            .subtract('year', 1)
            .format('YYYY-MM-DD') + ' 00:00:00';
        this.listRequestData.endTime = moment().format('YYYY-MM-DD') + ' 23:59:59';
        this.isReadonly = true;
      } else if (label === '2') {
        this.listRequestData.startTime = '';
        this.listRequestData.endTime = '';
        this.isReadonly = false;
      }
    }
  }
};
</script>
<style scoped lang="less">
.ebDateSearch {
  margin-top: 20px;
  .button {
    height: 22px;
    width: 82px;
  }
}
</style>
